'use strict';

import 'slick-carousel';

export const carousel = (() => {

    /**
     * init
     */
    const init = () => {

        $('.js-visual')
            .not('.slick-initialized')
            .slick({
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 800,
                cssEase: 'ease',
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                variableWidth: true
            });
    };

    return {
        init: init
    };
})();
